export default "__VITE_ASSET__Bduut2Ge__"